import React, { ReactElement } from 'react';
import style from './Text.module.css';
import { clsx } from 'clsx';

type Item = {
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  strikethrough?: boolean;
  text: string;
};

export default function Text({ item }: { item: Item }): ReactElement {
  let className = '';
  if (item.bold) {
    className = `${className} ${style.bold}`;
  }
  if (item.italic) {
    className = `${className} ${style.italic}`;
  }
  if (item.underline) {
    className = `${className} ${style.underline}`;
  }
  if (item.strikethrough) {
    className = `${className} ${style.strikethrough}`;
  }

  return <span className={clsx('whitespace-pre-line', className)}>{item.text}</span>;
}
